exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-personal .item-left{width:30%;display:inline-block}.list-personal .person-input{float:right;width:70%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.list-personal .person-hiden{text-align:right;color:#999}.list-personal .person-show{text-align:right;color:#333}.ipt-inline{border:none;font-size:.35rem}.logout{width:100%;height:1.5rem;margin-top:.266667rem;background-color:#fff;color:#fd0303}.save-btn{position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-62376e1c","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/profile/Personal.vue
// module id = 456
// module chunks = 0